import { useRef } from "react";
import ServiceCollabaxFilter from "../../Components/Filters/ServiceCollabaxFilter";
import ServiceColabaxTabs from "./ServiceCollabaxStatics/ServiceCollabaxTabs";
import { FaFileDownload } from "react-icons/fa";

const ServiceCollabax = () => {
  const tabsRef = useRef(null);

  const handleExportPDF = () => {
    tabsRef.current?.handleExportPDF();
  };

  return (
    <div className="flex flex-col flex-grow ">
      <div className="print:hidden flex flex-col md:flex-row p-2 justify-between gap-1 w-full">
        <div className="w-full md:w-[95%] ">
          <ServiceCollabaxFilter />
        </div>
        <button
          type="button"
          onClick={handleExportPDF}
          title="Export PDF"
          className="bg-[#2A5775] w-full md:w-[5%] text-center justify-center flex md:flex-col text-white p-2  items-center text-xs font-semibold gap-2 rounded-md"
        >
          Export PDF
          <FaFileDownload className="text-lg" />
        </button>
      </div>
      <ServiceColabaxTabs ref={tabsRef} />
    </div>
  );
};

export default ServiceCollabax;
